// @flow
import React from 'react';
// Модальное окно и прогрессбар
import LinearProgress from 'material-ui/LinearProgress';
import Dialog from 'material-ui/Dialog';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import FlatButton from 'material-ui/FlatButton';
// Relay
import * as MediaFileAddMutation from '../../mutations/MediaFileAddMutation';
import * as MediaFileEditMutation from '../../mutations/MediaFileEditMutation';
import modernEnvironment from '../../lib/RelayUtils';
// config
import { backendUrl } from '../../lib/config';
//
import setCategory from './setCategory';
// UI
import { closeBtn } from './modal-style';
import '../ui/form.css';
import '../ui/upload-window.css';

const progressStyle = {
	height: 17,
	borderRadius: 10,
};

type Props = {
	editMetaFile: Function,
	file: {
		lastModified: number,
		meta: ?string,
		name: string,
		newName: string,
		size: number,
		type: string,
	},
	getFileId: Function,
	orientation: ?string,
	sendLoadingStatus: Function,
	sendUploadStatus: Function,
};

type State = {
	componentStatus: ?string,
	errorMessage: ?string,
	errorOpen: boolean,
	errorTitle: string,
	fileError: boolean,
	fileInfo: ?string,
	filename: ?string,
	percent: number,
	progress: ?string,
	showLoader: boolean,
	statusTitle: ?string,
	status: ?string,
	upload: ?string,
	xhr: any,
};

class LoadItem extends React.Component<Props, State> {
	constructor(props) {
		super(props);
		this.state = {
			percent: 0,
			statusTitle: '',
			progress: '',
			showLoader: true,
			upload: '',
			componentStatus: '',
			fileError: false,
			filename: '',
			errorTitle: 'Ошибка',
			errorOpen: false,
			errorMessage: '',
			fileInfo: '',
			status: '',
			xhr: new XMLHttpRequest(),
		};
	}

	componentWillMount() {
		this.onFileUpload();
	}

	componentWillUnmount() {
		this.state.xhr.abort();
	}

	onFileUpload() {
		const { xhr } = this.state;
		const { file } = this.props;
		const fileMaxSize = 5368709120; // 1.5 Gb

		if (file.size >= fileMaxSize) {
			this.setState({
				fileError: true,
				errorOpen: true,
				errorMessage: `Файл должен быть менее ${fileMaxSize / 1024 / 1024} Mb`,
			});
			return;
		}

		this.setState({
			statusTitle: 'Загружается',
			filename: file.name,
			status: 'normal',
		});

		let type = 'image';
		if (file.type.indexOf('video/mp4') !== -1) {
			type = 'video';
		}

		const sendDataAdd = {
			filename: file.name,
			status: 'created',
			state: 'deleted',
			type,
		};

		MediaFileAddMutation.commit(modernEnvironment, sendDataAdd, (error, mediaFileId) => {
			if (!mediaFileId) {
				return;
			}

			const formData = new FormData();
			formData.append('file', file);
			formData.append('mediaFileId', mediaFileId);
			if (this.props.orientation && this.props.orientation !== 'default') {
				formData.append('orientation', this.props.orientation);
			}

			xhr.open('POST', `${backendUrl}/upload3`);
			this.props.sendLoadingStatus('loading');

			xhr.onload = () => {
				if (xhr.status !== 200) {
					console.log(error);
					console.log(xhr);
					return;
				}
				const data = JSON.parse(xhr.responseText);

				if (data.error) {
					this.setState({
						statusTitle: 'Минимальный размер изображения 800×450 пикселей, максимальный 1920х1080',
						status: 'error',
						showLoader: false,
					});
					if (type === 'video') {
						this.setState({
							statusTitle: 'Ошибка!',
							filename: data.errorDescription,
						});
					}
					this.props.sendUploadStatus({
						status: 'error',
					});
					return;
				}

				let preview = '';

				if (!data.filename) {
					this.props.sendLoadingStatus('done');
					return;
				}
				this.props.getFileId({ id: mediaFileId, fileName: file.name });
				if (file.type.indexOf('video/mp4') !== -1) {
					preview = `${data.filename.replace('.mp4', '')}/preview.jpg`;
				}
				let filter;
				if (type === 'video') {
					filter = setCategory();
				}
				const sendData = {
					id: mediaFileId,
					filename: data.filename,
					status: 'created',
					state: 'available',
					preview,
					type,
				};
				if (filter) {
					sendData.show = filter;
				}
				MediaFileEditMutation.commit(modernEnvironment, sendData, result => {
					if (!result) {
						return;
					}
					const fileInfo = {
						...data,
						id: mediaFileId,
						type,
					};

					setTimeout(() => {
						this.setState({ showLoader: false });
					}, 500);
					setTimeout(() => {
						this.setState({
							statusTitle: 'Готово!',
							upload: 'complete',
							fileInfo,
						});
						this.props.sendLoadingStatus('done');
						this.props.sendUploadStatus({
							id: mediaFileId,
							status: 'done',
							filename: data.filename,
							fileType: type,
						});
					}, 1000);
				});
			};

			xhr.onerror = e => {
				console.log(e);
				this.setState({
					statusTitle: 'Ошибка!',
					status: 'error',
				});
				this.props.sendUploadStatus({
					status: 'error',
				});
			};

			xhr.upload.onprogress = event => {
				setTimeout(() => {
					if (event.lengthComputable && this.state.status !== 'error') {
						const percent = Math.round((event.loaded / event.total) * 100);
						this.setState({ percent });
					}
				}, 250);
			};

			xhr.send(formData);
		});
	}

	/**
	 * Отмена загружаемого файла
	 */
	dropUpload = () => {
		this.state.xhr.abort();
		this.setState({ progress: 'hide' });
		// Удалить комнонент, после отображения анимации исчезновения блока
		setTimeout(() => {
			this.setState({ componentStatus: 'remove' });
		}, 1000);
	};
	/**
	 * Отправка данных по загруженному файлу родиельскому компоненту
	 * @returns {XML}
	 */
	uploadFileHandle = () => {
		if (this.state.upload === 'complete') {
			return (
				<span>
					<a className="file-name" onClick={() => this.props.editMetaFile(this.state.fileInfo)}>
						{this.state.filename}
					</a>
				</span>
			);
		}
		return this.state.filename;
	};

	/**
	 * Прогресс-бар
	 * @returns {XML}
	 */
	showProgressBar = () => (
		<div className={this.state.progress === 'hide' ? 'loader-wrapper__hide' : ''}>
			<div className="loader-inner">
				<header
					style={{
						color: this.state.status === 'error' ? '#d0021b' : '',
					}}
				>
					{this.state.statusTitle}
				</header>
				<div className="loader-header">
					<div
						className="loader-header--name"
						style={{
							color: this.state.upload === 'complete' ? '#000' : '',
						}}
					>
						{this.uploadFileHandle()}
					</div>
					{this.state.upload !== 'complete' && <CloseIcon style={closeBtn} color="#542376" onClick={this.dropUpload} />}
				</div>
				{this.state.showLoader && (
					<div className={this.state.percent === 100 ? 'progress-bar-wrapper progress-bar-wrapper__hide' : 'progress-bar-wrapper'}>
						<LinearProgress
							color={this.state.status === 'error' ? '#d0021b' : '#46bc98'}
							className="progress-bar"
							style={progressStyle}
							mode="determinate"
							value={this.state.percent}
						/>
					</div>
				)}
			</div>
		</div>
	);
	/**
	 * Сообщение об ошибке
	 * @returns {XML}
	 */
	errorFile = () => {
		const actions = [<FlatButton label="Ok" keyboardFocused={true} primary={true} onClick={() => this.setState({ errorOpen: false })} />];
		return (
			<Dialog title={this.state.errorTitle} actions={actions} modal={true} open={this.state.errorOpen}>
				{this.state.errorMessage}
			</Dialog>
		);
	};

	render() {
		if (this.state.componentStatus === 'remove') {
			return <div />;
		}
		if (this.state.fileError) {
			return this.errorFile();
		}
		return <div>{this.showProgressBar()}</div>;
	}
}

export default LoadItem;



// WEBPACK FOOTER //
// src/components/media/LoadItem.js